import { urlRegex } from './url_regex';

const urlPlaceholder = '$2xxxxxxxxxxxxxxxxxxxxxxx';

function escapeRegExp(str) {
  return str.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
}

export function countableText(inputText, mentionMap) {
  let result = inputText.replace(urlRegex, urlPlaceholder);
  console.log('countableText', { inputText, result, mentionMap });
  if (Array.isArray(mentionMap)) {
    mentionMap.forEach(({ display, username }) => {
      const pattern = new RegExp(`@${escapeRegExp(display)}\\b`, 'gi');
      result = result.replace(pattern, '@' + username);
    });
  }

  result = result.replace(/(^|[^/\w])@(([a-z0-9_]+)@[a-z0-9.-]+[a-z0-9]+)/ig, '$1@$3');
  
  return result;
}